import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SubscriptionPlan, SubscriptionStatus } from '@vi-iot/client';

import { BookingStore, BookingSubscription, BOOKING_SUBSCRIPTIONS_FILTER_TYPE } from '@store';
import { ViPanelComponent } from '@vi-iot/ui/index';
import { ChipFilterComponent } from 'src/app/shared/components/chip-filters/chip-filter/chip-filter.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PackagePerInstallationRowComponent } from '../package-per-installation-row/package-per-installation-row.component';
import { ChipFiltersComponent } from 'src/app/shared/components/chip-filters/chip-filters.component';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { SortBookingsPipe } from '../sort-bookings.pipe';

@Component({
  selector: 'app-package-per-installation-bookings',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    ViPanelComponent,
    MatCheckboxModule,
    ChipFiltersComponent,
    ChipFilterComponent,
    SortBookingsPipe,
    PackagePerInstallationRowComponent,
  ],
  templateUrl: './package-per-installation-bookings.component.html',
  styleUrls: ['./package-per-installation-bookings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackagePerInstallationBookingsComponent {
  @Input() subscriptions: BookingSubscription[];

  readonly subscriptionsStatusType = SubscriptionStatus;
  readonly subscriptionPlan = SubscriptionPlan;
  readonly subscriptionsFilterType = BOOKING_SUBSCRIPTIONS_FILTER_TYPE;
  readonly numberOfRowsWithoutScrollbar: number = 2;

  activeSubscriptionsFilter = BOOKING_SUBSCRIPTIONS_FILTER_TYPE.ALL;

  constructor(public bookingStore: BookingStore) {}

  setFilter(subscriptionFilter: BOOKING_SUBSCRIPTIONS_FILTER_TYPE): void {
    this.activeSubscriptionsFilter = subscriptionFilter;
  }
}
